function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Bulb24(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      "clip-path": "url(#clip0_1014_8341)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8.58998 18.81V17.74C6.46998 16.46 4.72998 13.96 4.72998 11.31C4.72998 6.75002 8.91998 3.18002 13.66 4.21002C15.74 4.67002 17.57 6.05002 18.52 7.96002C20.45 11.83 18.42 15.94 15.44 17.73V18.8C15.44 19.07 15.54 19.68 14.56 19.68H9.47998C8.46998 19.68 8.59998 19.29 8.59998 18.8L8.58998 18.81Z",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.99023 21.9H15.0102",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.7202 11.3199H22.4602",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.3398 6.47998L20.9898 6.09998",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.73 2.96996L17.11 2.32996",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.8599 1.74V1",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.02014 3.11997L6.64014 2.46997",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.51012 6.72998L2.87012 6.34998",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M2.28004 11.6H1.54004",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1014_8341",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      })
    })]
  }));
}